import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DeleteLostAndFoundIssueBulkResponse,
  DeleteLostAndFoundIssueInput,
  MutationDeleteLostAndFoundIssueBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { DeleteLostAndFoundIssue } from '../queries/DeleteLostAndFoundIssue';
import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteLostAndFoundIssueInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteLostAndFoundIssueBulkResponse>;
}

// SearchLostAndFoundIssue Service
export const { deleteLostAndFoundIssue, useDeleteLostAndFoundIssue } = ((): {
  deleteLostAndFoundIssue: ServiceMethod;
  useDeleteLostAndFoundIssue: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteLostAndFoundIssue).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: DeleteLostAndFoundIssueInput[], options?: ConnectionOptions): Promise<DeleteLostAndFoundIssueBulkResponse> => {
        const search: DeleteLostAndFoundIssueInput[] = payload;
        const args: MutationDeleteLostAndFoundIssueBulkArgs = {
          input: {
            search,
          },
        };
        const opts = { merge: options?.merge ? 'deleteLostAndFoundIssueBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteLostAndFoundIssueBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteLostAndFoundIssue: fetch,
    useDeleteLostAndFoundIssue: useService,
  };
})();
